import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  noDesc?: boolean;
  title?: string;
  subtitle?: string;
}
const EmptyTableMessage: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const { noDesc, title, subtitle } = props;

  return (
    <div className="empty-table-message">
      <div className="empty-table-message__logo" />
      <p className="firstTitle">{title || t('sorry')}</p>
      <p className="secondTitle">{subtitle || t('noRecords')}</p>

      {!noDesc && (
        <>
          <p>{t('noRecordsFilter')}</p>
          <p>{t('noRecordsCriteria')}</p>
        </>
      )}
    </div>
  );
};

export default EmptyTableMessage;
